
import { Auth as SupabaseAuth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { supabase } from "@/integrations/supabase/client";
import { authConfig } from "./authConfig";

type AuthView = 'sign_in' | 'sign_up' | 'update_password';

interface SupabaseAuthFormProps {
  view: AuthView;
  onError: (error: string) => void;
}

export const SupabaseAuthForm = ({ view, onError }: SupabaseAuthFormProps) => {
  return (
    <SupabaseAuth
      supabaseClient={supabase}
      appearance={{
        theme: ThemeSupa,
        variables: {
          default: {
            colors: {
              brand: "#2AA99B",
              brandAccent: "#008C8C",
            },
          },
        },
        className: {
          button: "w-full bg-everest-teal hover:bg-everest-teal/90 text-white font-semibold py-2 px-4 rounded-md transition-colors",
          container: "space-y-4",
          label: "block text-sm font-medium text-gray-700",
          input: "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-everest-teal focus:ring-everest-teal sm:text-sm",
          loader: "text-everest-teal",
        },
      }}
      view={view}
      providers={[]}
      redirectTo={view === 'update_password' ? undefined : `${window.location.origin}/auth`}
      showLinks={false}
      onlyThirdPartyProviders={false}
      localization={{
        variables: {
          sign_in: {
            email_label: "Email address",
            password_label: "Password",
            button_label: "Sign in",
            loading_button_label: "Signing in...",
          },
          sign_up: {
            email_label: "Email address",
            password_label: "Password",
            button_label: "Sign up",
            loading_button_label: "Signing up...",
          },
          update_password: {
            password_label: "New password",
            button_label: "Update password",
            loading_button_label: "Updating password...",
          },
        },
      }}
    />
  );
};
